import React, { JSX } from "react";
import { ExpandMore } from "@mui/icons-material";
import TextField from "@mui/material/TextField";
import { Autocomplete } from "@mui/material";
import useDepartmentServiceProviders from "../../hooks/useDepartmentServiceProviders";
import { ServiceProvider } from "../../interfaces/ServiceProvidersInterface";

interface Props {
  onChange: (sp: ServiceProvider) => void;
}

const BookingServiceProviderUpdaterSelect = ({ onChange }: Props): JSX.Element => {
  const serviceProviderList = useDepartmentServiceProviders();

  return (
    <div>
      <Autocomplete
        fullWidth
        disableClearable
        options={serviceProviderList}
        getOptionLabel={(option) =>
          option.title
            ? `${
                option.title.charAt(0).toUpperCase() + option.title.slice(1)
              } ${option.firstName.toUpperCase()} ${option.lastName.toUpperCase()}`
            : ` ${option.firstName.toUpperCase()} ${option.lastName.toUpperCase()}`
        }
        onChange={(_, v) => {
          if (typeof v === "string") return;
          onChange(v);
        }}
        popupIcon={<ExpandMore style={{ color: "black" }} />}
        renderOption={(params, option) => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <li {...params} key={option.id} style={{ fontSize: "12px" }}>
            {option.title
              ? `${
                  option.title.charAt(0).toUpperCase() + option.title.slice(1)
                } ${option.firstName.toUpperCase()} ${option.lastName.toUpperCase()}`
              : ` ${option.firstName.toUpperCase()} ${option.lastName.toUpperCase()}`}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...params}
            required
            label="Select service provider"
            placeholder="Assign service provider"
            data-testmation="serviceProviderSelectTextfield"
            variant="outlined"
            helperText=" "
            slotProps={{
              inputLabel: { shrink: true },
              input: {
                ...params.InputProps,
                disableUnderline: true,
                style: {
                  fontSize: "12px"
                }
              }
            }}
          />
        )}
      />
    </div>
  );
};

export default BookingServiceProviderUpdaterSelect;
